import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DashboardStatData } from '../../shared/types';
import { MobileDetectionMixin } from '../../shared/mixins/mobile-detection.mixin';

@Component({
  selector: 'app-campaign-bottom-card',
  standalone: true,
  imports: [CommonModule, MatTooltipModule],
  templateUrl: './campaign-bottom-card.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./campaign-bottom-card.component.scss'],
})
export class CampaignBottomCardComponent extends MobileDetectionMixin {
  @Input() data!: DashboardStatData;
}
